import { atom, useAtom } from "jotai";
import { useContext } from "react";
import useStore from "../../../../../../../../../../context/useStore";
import dataService from "../../../../../../../../../../helpers/dataService";
import { getPolicyReceipts } from "../../../../../../../../../../services/policyService";
import { ClientContext } from "../../../../../../ClientContext/ClientContext";
import useContextualTimeline from "../../../../../useContextualTimeline/useContextualTimeline";
import useCompanyPolicies from "../useCompanyPolicies";

const companyPolicyAtom = atom(null);
const policyAtom = atom(null);
const bottomPanelContentAtom = atom("");
const isLoadingReceiptsAtom = atom(false);

const usePolicyItem = () => {
  const [state] = useStore();
  const { POLICIES_STATUS, PERIODICITIES, PAYMENT_STATUS } = state.constants.items;
  const { products, productTypes, insuranceCompanies } = useContext(ClientContext);
  const { isLoadingCompanyPolicies } = useCompanyPolicies();
  const [policy, setPolicy] = useAtom(policyAtom);
  const [companyPolicy, setCompanyPolicy] = useAtom(companyPolicyAtom);
  const [bottomPanelContent, setBottomPanelContent] = useAtom(bottomPanelContentAtom);
  const [isLoadingPolicyReceipts, setIsLoadingPolicyReceipts] = useAtom(isLoadingReceiptsAtom);
  const { openTimeline } = useContextualTimeline();
  const bottomPanels = [
    {
      name: "Documents",
      content: "DOCUMENTS",
      dataPriv: `app_downloadcompanycontractdocs-${policy?.client}`,
    },
    { name: "Avenants", content: "AMENDMENTS", dataPriv: `app_viewpayments-${policy?.client}` },
    { name: "Quittances", content: "RECEIPTS", dataPriv: `app_viewpayments-${policy?.client}` },
    {
      name: "Événements de ce contrat",
      content: "EVENTS",
      onClick: () => openTimeline({ model: "policies", id: policy.id }),
    },
  ];

  const initPolicy = (policyData) => {
    setPolicy(policyData);
  };
  const initCompanyPolicy = (companyData) => {
    setCompanyPolicy(companyData);
  };

  const openBottomPanel = (content) => {
    if (content == bottomPanelContent) {
      setBottomPanelContent("");
    } else {
      setBottomPanelContent(content);
    }
  };

  const onGetPolicyReceipts = () => {
    setIsLoadingPolicyReceipts(true);
    getPolicyReceipts(policy.id)
      .then((data) => {
        let policyReceipts = data;
        dataService.getMany(
          data.map((receipt) => ({
            type: "GET",
            path: `receipts/${receipt.id}/payments`,
            name: receipt.id,
          })),
          (recData) => {
            Object.keys(recData).forEach((receiptId) => {
              let recRef = recData[receiptId];
              policyReceipts.find((r) => r.id == receiptId).payments = recRef;
            });

            setPolicy({ ...policy, receipts: policyReceipts });
          },
          (err) => {},
          () => setIsLoadingPolicyReceipts(false)
        );
      })
      .catch((err) => setIsLoadingPolicyReceipts(false));
  };

  return {
    POLICIES_STATUS,
    PERIODICITIES,
    PAYMENT_STATUS,
    products,
    productTypes,
    insuranceCompanies,
    isLoadingCompanyPolicies,
    policy,
    companyPolicy,
    bottomPanels,
    bottomPanelContent,
    isLoadingPolicyReceipts,
    policyActions: { initPolicy, initCompanyPolicy, openBottomPanel, onGetPolicyReceipts },
  };
};

export default usePolicyItem;
